import languageJson from './es.json';

export default languageJson;
